<div id="container" [class.mac]="isMac()">
  <div *ngIf="nativeService.isElectronApp && !isMac()" id="icon-container">
    <div id="icon"></div>
  </div>
  <div class="draggable" *ngIf="appStateService.appWindowState !== AppWindowState.Main || headlessMode"></div>
  <div class="draggable" *ngIf="appStateService.appWindowState !== AppWindowState.Main || headlessMode"></div>
  <div id="nav-container" *ngIf="appStateService.appWindowState === AppWindowState.Main && !headlessMode">
    <div id="nav">
      <div id="clean-cache"><i (click)="cleanCache()" class="fas fa-sync-alt no-pad"></i></div>
      <div class="clamp-one-row" id="url" (click)="copyUrl()">{{tabbingService.visibleTab.navigationData.url}}</div>
      <div id="paste"><i (click)="pasteUrl()" class="far fa-clipboard no-pad"></i></div>
    </div>
  </div>
  <div id="title" *ngIf="appStateService.appWindowState === AppWindowState.Main && !headlessMode">
    <div id="tabs">
      <div #horizontalScroll (mousewheel)="scrollTabs($event)" class="verticalScrollable">
        <div style="height: 100%; width: 5px; display: inline-block"></div>
        <div (click)="addNewTab()" class="tab first selected"><i class="fas fa-plus"></i></div>
          <div (click)="selectTab(tab)"
               *ngFor="let tab of tabbingService.tabs; let i = index"
               [class.last]="i === tabbingService.tabs.length"
               [class.selected]="tab === tabbingService.visibleTab"
               class="tab">
            <i [className]="tab.icon"></i>
            {{tab.header}}
            <i (click)="closeTab(tab)" class="fas fa-times"></i>
          </div>
        <div class="draggable"></div>
      </div>
    </div>
  </div>
  <div id="buttons-win" *ngIf="!isMac()">
    <div (click)="exit()" class="fr button exit" id="exit"><i
      class="far icon-win fa-times-circle"></i></div>
    <div (click)="maximize()" class="fr button" id="maximize"><i
      class="far icon-win fa-window-maximize"></i></div>
    <div (click)="minimize()" class="fr button" id="minimize"><i
      class="far icon-win fa-window-minimize"></i></div>
    <div (click)="openSettings()" *ngIf="showSettings" class="fr button" id="settings"><i class="fas icon-win fa-cogs"></i></div>
    <app-feedback *ngIf="appStateService.appWindowState === AppWindowState.Main && !headlessMode"></app-feedback>
  </div>
  <div id="buttons-mac" *ngIf="isMac()">
    <div class="button-mac exit-mac" (click)="exit()"><i class="fas icon-mac fa-times"></i></div>
    <div class="button-mac maximize-mac" (click)="maximize()"><i class="far icon-mac fa-square"></i></div>
    <div class="button-mac minimize-mac" (click)="minimize()"><i class="far icon-mac fa-window-minimize"></i></div>
  </div>
  <div id="separator"></div>
</div>
